"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectAfterMoveActionOption_1 = require("../actions/selectAfterMoveActionOption");
var selectLoadMessageOnSignOnOption_1 = require("../actions/selectLoadMessageOnSignOnOption");
var selectReadingPanePositionOption_1 = require("../actions/selectReadingPanePositionOption");
var store_1 = require("../store/store");
var owa_choice_group_with_images_1 = require("owa-choice-group-with-images");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
var owa_options_core_1 = require("owa-options-core");
var owa_session_store_1 = require("owa-session-store");
var ReadingPanePosition_1 = require("owa-session-store/lib/store/schema/ReadingPanePosition");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var READING_PANE_RIGHT_SVG = require('./readingPaneRightLarge.svg');
var READING_PANE_OFF_SVG = require('./readingPaneOffLarge.svg');
var READING_PANE_BOTTOM_SVG = require('./readingPaneBottomLarge.svg');
var ReadingPaneFull = /** @class */ (function (_super) {
    tslib_1.__extends(ReadingPaneFull, _super);
    function ReadingPaneFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onAfterMoveActionChange = function (ev, option) {
            selectAfterMoveActionOption_1.default(option.key);
        };
        _this.onChangeReadingPane = function (ev, option) {
            selectReadingPanePositionOption_1.default(parseInt(option.key, 10));
        };
        _this.onChangeLoadMessage = function (ev, option) {
            selectLoadMessageOnSignOnOption_1.default(option.key === 'true');
        };
        return _this;
    }
    ReadingPaneFull.prototype.render = function () {
        var _a = this.props, userOptions = _a.userOptions, optionState = _a.optionState;
        var readingPanePositionSelectedKey = "" + owa_options_core_1.getFallbackValueIfNull(optionState.readingPanePosition, userOptions.GlobalReadingPanePositionReact);
        var actionAfterMoveKey = optionState.nextSelection || userOptions.NextSelection;
        var showReadingPaneOnFirstLoadSelectedKey = "" + owa_options_core_1.getFallbackValueIfNull(optionState.loadMessageOnLogOn, userOptions.ShowReadingPaneOnFirstLoad);
        // Account for the case where RP is not 'Off', but we should 'ReturnToView' after move/delete
        // This is done in the view to preserve the underlying selection if a users switches RP position back and forth
        if (readingPanePositionSelectedKey !== "" + ReadingPanePosition_1.default.Off &&
            actionAfterMoveKey === 'ReturnToView') {
            actionAfterMoveKey = 'Next';
        }
        var options = [
            {
                key: "" + ReadingPanePosition_1.default.Right,
                text: owa_options_strings_1.default.options_readingPane_positionRight,
                imageUri: READING_PANE_RIGHT_SVG,
                width: 280,
            },
            {
                key: "" + ReadingPanePosition_1.default.Bottom,
                text: owa_options_strings_1.default.options_readingPane_positionBottom,
                imageUri: READING_PANE_BOTTOM_SVG,
                width: 280,
            },
            {
                key: "" + ReadingPanePosition_1.default.Off,
                text: owa_options_strings_1.default.options_readingPane_positionHide,
                imageUri: READING_PANE_OFF_SVG,
                width: 280,
            },
        ];
        return (React.createElement("div", null,
            React.createElement(owa_choice_group_with_images_1.ChoiceGroupWithImages, { selectedKey: readingPanePositionSelectedKey, label: owa_options_strings_1.default.options_readingPane_positionLabel, options: options, onChange: this.onChangeReadingPane }),
            React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: actionAfterMoveKey, label: owa_options_strings_1.default.options_readingPane_afterMove_title, options: [
                    {
                        key: 'Next',
                        text: owa_options_strings_1.default.options_readingPane_afterMove_next,
                    },
                    {
                        key: 'Previous',
                        text: owa_options_strings_1.default.options_readingPane_afterMove_previous,
                    },
                    {
                        key: 'ReturnToView',
                        text: owa_options_strings_1.default.options_readingPane_afterMove_returnToView,
                        disabled: readingPanePositionSelectedKey !== "" + ReadingPanePosition_1.default.Off,
                    },
                ], onChange: this.onAfterMoveActionChange }),
            React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: showReadingPaneOnFirstLoadSelectedKey, label: owa_options_strings_1.default.options_readingPane_actionOnLoadLabel, options: [
                    {
                        key: 'true',
                        text: owa_options_strings_1.default.options_readingPane_actionOnLoadFirstItem,
                    },
                    {
                        key: 'false',
                        text: owa_options_strings_1.default.options_readingPane_actionOnLoadNoAction,
                    },
                ], onChange: this.onChangeLoadMessage })));
    };
    ReadingPaneFull = tslib_1.__decorate([
        react_1.reactive({
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
            optionState: function () { return store_1.default; },
        })
    ], ReadingPaneFull);
    return ReadingPaneFull;
}(React.Component));
exports.default = ReadingPaneFull;
//# sourceMappingURL=ReadingPaneFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-reading-pane-option/lib/components/ReadingPaneFull.js
// module id = 5115
// module chunks = 2